import * as React from 'react';

import EmailMarketingSvg from '../assets/email-marketing.svg';

import styles from './help-graphic-email-marketing.module.css';

export class HelpGraphicEmailMarketing extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <EmailMarketingSvg />
            </div>
        );
    }
}
